import { BridgeableTokenData, BridgeableTokens } from "../types"

import {
  cbBTC,
  DAI,
  fBTC,
  MezoNativeBTC,
  SolvBTC,
  swBTC,
  T,
  tBTC,
  USDC,
  USDe,
  USDT,
  xSolvBTC,
} from "./artifacts"
import {
  ONE_HOUR_IN_SECONDS,
  ONE_MINUTE_IN_SECONDS,
  ONE_SECOND_IN_MILLISECONDS,
} from "./time"

const ESTIMATED_ERC20_BRIDGE_TIME =
  15 * ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS

// Native BTC will first go through the tBTC network and will take 1 to 3 hours
// to mint tBTC token, depending on the deposited amount.
const ESTIMATED_NATIVE_BTC_BRIDGE_TIME = {
  // 2 hour
  min: 2 * ONE_HOUR_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS,
  // 4 hour
  max: 4 * ONE_HOUR_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS,
}

const BRIDGEABLE_TOKENS: Record<BridgeableTokens, BridgeableTokenData> = {
  BTC: {
    // The native BTC is represented as tBTC. Useful when bridging portal BTC
    // deposit to Mezo chain.
    sourceToken: tBTC.address,
    mezoToken: MezoNativeBTC.address,
    bridgedTokenSymbol: "BTC",
  },
  tBTC: {
    sourceToken: tBTC.address,
    // Only tBTC is bridged as BTC to Mezo.
    mezoToken: MezoNativeBTC.address,
    bridgedTokenSymbol: "BTC",
  },
  T: {
    sourceToken: T.address,
    mezoToken: T.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mT",
  },
  cbBTC: {
    sourceToken: cbBTC.address,
    mezoToken: cbBTC.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mcbBTC",
  },
  fBTC: {
    sourceToken: fBTC.address,
    mezoToken: fBTC.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mfBTC",
  },
  swBTC: {
    sourceToken: swBTC.address,
    mezoToken: swBTC.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mswBTC",
  },
  SolvBTC: {
    sourceToken: SolvBTC.address,
    mezoToken: SolvBTC.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mSolvBTC",
  },
  xSolvBTC: {
    sourceToken: xSolvBTC.address,
    mezoToken: xSolvBTC.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mxSolvBTC",
  },
  DAI: {
    sourceToken: DAI.address,
    mezoToken: DAI.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mDAI",
  },
  USDC: {
    sourceToken: USDC.address,
    mezoToken: USDC.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mUSDC",
  },
  USDT: {
    sourceToken: USDT.address,
    mezoToken: USDT.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mUSDT",
  },
  USDe: {
    sourceToken: USDe.address,
    mezoToken: USDe.mezoBridgedAssetAddress,
    bridgedTokenSymbol: "mUSDe",
  },
}

export default {
  BRIDGEABLE_TOKENS,
  ESTIMATED_ERC20_BRIDGE_TIME,
  ESTIMATED_NATIVE_BTC_BRIDGE_TIME,
}
